var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseScreen',_vm._b({},'BaseScreen',_vm.screen,false),[(_vm.isErrorVisible)?_c('BaseAlert',_vm._b({attrs:{"slot":"middle"},slot:"middle"},'BaseAlert',_vm.error,false)):_vm._e(),_c('BaseMenu',{attrs:{"items":_vm.menuItems}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }